export const userHasLimits = async () => {
  return fetch('/signup/i/user_has_limits/')
    .then((response) => {
      if (!response.ok) {
        return {
          has_custom_limits: false,
        };
      }
      return response.json();
    })
    .then((res) => res.has_custom_limits)
    .catch((e) => {
      console.error(e);
      return false;
    });
};
